// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CandidatesController from "./candidates_controller"
application.register("candidates", CandidatesController)

import CascadingController from "./cascading_controller"
application.register("cascading", CascadingController)

import CascadingSelectController from "./cascading_select_controller"
application.register("cascading-select", CascadingSelectController)

import ContactsController from "./contacts_controller"
application.register("contacts", ContactsController)

import ContentFilterController from "./content_filter_controller"
application.register("content-filter", ContentFilterController)

import ContentcategoriesController from "./contentcategories_controller"
application.register("contentcategories", ContentcategoriesController)

import ContentcategoryFilterController from "./contentcategory_filter_controller"
application.register("contentcategory-filter", ContentcategoryFilterController)

import CreditController from "./credit_controller"
application.register("credit", CreditController)

import CreditnoteController from "./creditnote_controller"
application.register("creditnote", CreditnoteController)

import DocumentsController from "./documents_controller"
application.register("documents", DocumentsController)

import ExpertisesController from "./expertises_controller"
application.register("expertises", ExpertisesController)

import FunctionalareaController from "./functionalarea_controller"
application.register("functionalarea", FunctionalareaController)

import GuestsController from "./guests_controller"
application.register("guests", GuestsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HospitalityAllocationsController from "./hospitality_allocations_controller"
application.register("hospitality-allocations", HospitalityAllocationsController)

import IncomingInvoiceLineAllocationsController from "./incoming_invoice_line_allocations_controller"
application.register("incoming-invoice-line-allocations", IncomingInvoiceLineAllocationsController)

import IncomingInvoiceLineCalculatorController from "./incoming_invoice_line_calculator_controller"
application.register("incoming-invoice-line-calculator", IncomingInvoiceLineCalculatorController)

import IncomingInvoiceLinesController from "./incoming_invoice_lines_controller"
application.register("incoming-invoice-lines", IncomingInvoiceLinesController)

import InvoiceNotesController from "./invoice_notes_controller"
application.register("invoice-notes", InvoiceNotesController)

import InvoiceRevenuePeriodsController from "./invoice_revenue_periods_controller"
application.register("invoice-revenue-periods", InvoiceRevenuePeriodsController)

import JobappController from "./jobapp_controller"
application.register("jobapp", JobappController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import OfferItemsController from "./offer_items_controller"
application.register("offer-items", OfferItemsController)

import OfferLineController from "./offer_line_controller"
application.register("offer-line", OfferLineController)

import OfferTotalController from "./offer_total_controller"
application.register("offer-total", OfferTotalController)

import OffersController from "./offers_controller"
application.register("offers", OffersController)

import OrderItemsController from "./order_items_controller"
application.register("order-items", OrderItemsController)

import PositioncategoriesController from "./positioncategories_controller"
application.register("positioncategories", PositioncategoriesController)

import ProductFillController from "./product_fill_controller"
application.register("product-fill", ProductFillController)

import ReceiptsController from "./receipts_controller"
application.register("receipts", ReceiptsController)

import RevenueAllocationsController from "./revenue_allocations_controller"
application.register("revenue-allocations", RevenueAllocationsController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SpendingContactController from "./spending_contact_controller"
application.register("spending-contact", SpendingContactController)

import SpendingContactsController from "./spending_contacts_controller"
application.register("spending-contacts", SpendingContactsController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)

import TaskController from "./task_controller"
application.register("task", TaskController)

import VatItemsController from "./vat_items_controller"
application.register("vat-items", VatItemsController)

import YearSelectorController from "./year_selector_controller"
application.register("year-selector", YearSelectorController)
